import ApiCore from '../api-core'
import { ACTIVE_BASE_REST } from '../constants'

export default class BulkUpload extends ApiCore {
  constructor(store) {
    const path = ACTIVE_BASE_REST
    super(store, path)
  }

  upload(url, model) {
    return this._request({
      action: `${url}/import`,
      method: 'POST',
      body: model
    })
  }
}
